export default __webpack_public_path__ + "static/Estrella_de_medianoche-51a77800c7cf452318b2dcfe4bf9fd4e.mp3";